import {lazy,Suspense} from "react";
import {ArrowRight,HardDrive,UserX} from "lucide-react";
import {useI18n} from "../../i18n";
import {DownloadButton} from "./DownloadSection";
const HeroModel=lazy(()=>import("./hero-model/HeroModel"));
export function HomeHero({sizeMb}:{sizeMb?:string}) {
  const {t}=useI18n();
  return <section className="home-hero home-hero-assembly"><div className="container home-hero-layout">
    <div className="home-hero-copy">
      <h1>{t("home.title1")}<em>{t("home.title2")}</em></h1>
      <p className="lead">{t("home.assembly.lead")}</p>
      <div className="home-cta"><DownloadButton sizeMb={sizeMb}/><a className="button large" href="#how">{t("home.ctaHow")}<ArrowRight size={15} aria-hidden/></a></div>
      <ul className="home-trust"><li><UserX size={14} aria-hidden/>{t("home.trustNoAccount")}</li><li><HardDrive size={14} aria-hidden/>{t("home.trustLocal")}</li></ul>
    </div>
    <Suspense fallback={<div className="home-assembly home-assembly-loading" role="status">{t("home.assembly.loading")}</div>}><HeroModel/></Suspense>
  </div></section>;
}
